module.exports = __webpack_public_path__ + "assets/img/3.675dee26.jpg";